import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import * as React from 'react';

import { useTimezone } from '@/hooks/useTimezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const EventTime: React.FC<{
  startDate: string;
  endDate: string;
  eventTimezone?: string;
  showBrowserTimezone?: boolean;
}> = React.memo((props) => {
  const { rawTimezone, readableTimezone } = useTimezone(
    props.eventTimezone,
    props.showBrowserTimezone
  );

  const today = dayjs();
  const startDate = dayjs(props.startDate).tz(rawTimezone);
  const endDate = dayjs(props.endDate).tz(rawTimezone);

  const isSameDay = startDate.isSame(endDate, 'day');
  const isSameYear = startDate.isSame(endDate, 'year');
  const isSameMeridiem = startDate.hour() < 12 === endDate.hour() < 12;

  const isSameYearAsToday =
    startDate.isSame(today, 'year') || endDate.isSame(today, 'year');

  const { startString, endString } = (() => {
    if (!isSameYear) {
      return {
        startString: startDate.format('MMM D, YYYY h:mm A'),
        endString: endDate.format('MMM D, YYYY h:mm A'),
      };
    }

    if (!isSameDay) {
      return {
        startString: startDate.format(
          `MMM D,${isSameYearAsToday ? '' : ' YYYY'} h:mm A`
        ),
        endString: endDate.format(
          `MMM D,${isSameYearAsToday ? '' : ' YYYY'} h:mm A`
        ),
      };
    }

    if (!isSameMeridiem) {
      return {
        startString: startDate.format(
          `MMM D,${isSameYearAsToday ? '' : ' YYYY'} h:mm A`
        ),
        endString: endDate.format('h:mm A'),
      };
    }

    return {
      startString: startDate.format(
        `MMM D,${isSameYearAsToday ? '' : ' YYYY'} h:mm`
      ),
      endString: endDate.format('h:mm A'),
    };
  })();

  return <>{`${startString} - ${endString}${readableTimezone}`}</>;
});

EventTime.displayName = 'EventTime';
